// extracted by mini-css-extract-plugin
module.exports = {"buttons":"styles-module--buttons--1wb4W","buttonsItem":"styles-module--buttonsItem--2fsCD","active":"styles-module--active--ezw8L"};